import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import "./CustomerHistoryShow.css";
import { Button, Col, Form, Table } from "react-bootstrap";
import { getData, getDownloadDataExcel, postData } from "../../../../utils/api";
import ModalSave from "../../ModalSave";
import ModalComplaintSave from "../../ModalComplaintSave";
import ProductStatusChange from "../../modal/productStatusChange/ProductStatusChange";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CustomerHistoryShow = ({
  show,
  onHide,
  setErr,
  customer_id,
  HistoryData,
  getAllData,
}) => {
  const [data, setData] = useState([]);

  const [showChange, setShowChange] = useState(false);
  const [showData, setShowData] = useState("");

  const getAllProductData = async () => {
    {
      const res = await getData(
        `/complaint-management/complaints/all-complaint-of-customer/${customer_id}`,
      );
      setData(res?.data);
    }
  };

  useEffect(() => {
    getAllProductData();
  }, [customer_id]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [fullscreen, setFullscreen] = useState(true);

  const HandleDownload = async () => {
    try {
      await getDownloadDataExcel(
        "/complaint-management/complaints/customer-complaint-history",
        { id: customer_id },
        `Customer Complaint History`,
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Modal
      className="common_modal Service_History_modal CustomerHistoryShow_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      fullscreen={fullscreen}
      size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Customer Complaint History</Modal.Title>
      </Modal.Header>

      {data?.length > 0 && (
        <Col xl={3} lg={3} md={8} sm={6} className="my-auto">
          <Form.Label>
            <div className="Search-1 ">
              <button
                className="view_btn  btn btn-danger"
                onClick={HandleDownload}>
                Download data in Excel &nbsp;
                <FontAwesomeIcon
                  icon="fa-solid fa-file-lines "
                  // className="pdf-icon"
                  // variant="success"
                />
              </button>
            </div>
          </Form.Label>
        </Col>
      )}
      <Modal.Body>
        <div className="row mt-3">
          <div className="data table-responsive">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Complaint No</th>
                  <th>Customer Name</th>
                  <th>Complaint Type</th>
                  <th>Visit Type</th>
                  <th>Charges</th>
                  <th>Service Engineer</th>
                  <th>Schedule Date</th>
                  <th>Schedule Time</th>
                  <th>Service Call No</th>
                  <th>Completion Date</th>
                  <th>Mobile no for SMS</th>
                  <th>Remark</th>
                  <th>Case Priority</th>
                  <th>Support</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {data?.length > 0 ? (
                  data?.map((d, index) => (
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      <td>{d?.complaints_no}</td>
                      <td>{d?.customer?.name}</td>
                      <td>{d?.complaint_type?.name || "-"}</td>
                      <td>{d?.visit_type?.name || "-"}</td>
                      <td>₹ {d?.charges || 0}</td>
                      <td>{d?.service_engineer?.name || "-"}</td>
                      <td>{d?.schedule_date || "-"}</td>
                      <td>{d?.schedule_time || "-"}</td>
                      <td>{d?.service_call_no || "-"}</td>
                      <td>{d?.completion_time || "-"}</td>
                      <td>{d?.mobile_no_for_sms || "-"}</td>
                      <td>{d?.remark || "-"}</td>
                      <td>{d?.complaint_priority?.name || "-"}</td>
                      <td>{d?.support_status ? "True" : "False"}</td>
                      <td>{d?.complaint_status?.name || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      style={{ textAlign: "center", padding: "10px" }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="btn_holder"></div>
      </Modal.Body>
      <ModalComplaintSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </Modal>
  );
};

export default CustomerHistoryShow;
